import "./SelectOrganization.scss";
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Select } from "../../Components/index";
import { LeftArrowIcon } from "../../assets/icons/leftArrowIcon";
import config from "../../config";
import { useAppContext } from "../../Components/Context/AppContext";
import { toast } from "react-toastify";
import userOrganizationsHelper from "../../helpers/formTools/userOrganizations/index.js";
import CustomModal from "../../Components/Common/CustomModal";

const NO_ORG_MESSAGE =
  "Il tuo account non è collegato a nessuna ente gestito in Archeo. Per accedere ad Archeo, rivolgiti all'Amministrazione di riferimento per abilitare l'accesso.";

export function SelectOrganization() {
  const { userProfile, setLayers } = useAppContext();
  const navigate = useNavigate();
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [organizations, setOrganizations] = useState([]);
  const [isNoOrgModalVisible, setIsNoOrgModalVisible] = useState(false);

  const handleNoOrgModalClose = useCallback(() => {
    setIsNoOrgModalVisible(false);
    navigate("/signin");
  }, [navigate]);

  useEffect(() => {
    if (userProfile) {
      const organizations = userOrganizationsHelper(userProfile);
      if (organizations.length > 1) {
        setOrganizations(organizations);
      } else if (organizations.length === 1) {
        navigate("/home");
        localStorage.setItem("organization", JSON.stringify(organizations[0]));
        setLayers([]);
      } else {
        setIsNoOrgModalVisible(true);
      }
    }
  }, [userProfile, navigate, setLayers]);

  const handleSelectOrganization = (selectedOption) => {
    setSelectedOrg(selectedOption);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedOrg) {
      const organization = {
        name: selectedOrg.value,
        id: selectedOrg.uniqueId,
        comune: selectedOrg.comune,
      };
      localStorage.setItem("organization", JSON.stringify(organization));
      navigate("/home");
    } else {
      toast.error("Please select an organization");
    }
  };

  const customOptions = organizations.map((org, index) => ({
    value: org.id !== null ? org.name : config.adminOrganization,
    id: `org-${index + 1}`,
    uniqueId: org?.id,
  }));

  return (
    <React.Fragment>
      <form className="select-organization-form" onSubmit={handleSubmit}>
        <div className="header-container">
          <h1 className="title">Seleziona Organizzazione</h1>
          <p className="description">
            Seleziona l'organizzazione con cui vuoi accedere al sistema.
          </p>
        </div>

        <div className="organization-select-container">
          <Select
            options={customOptions}
            placeholder="Seleziona un'organizzazione"
            onSelect={handleSelectOrganization}
            isDisabled={false}
          />
        </div>

        <button
          type="submit"
          className="button-confirm-container"
          disabled={!selectedOrg}
        >
          <span className="button-text">Continua</span>
          <LeftArrowIcon />
        </button>
      </form>

      <CustomModal
        title="Accesso non abilitato"
        isVisible={isNoOrgModalVisible}
        onClose={handleNoOrgModalClose}
        closeOnOverlayClick={false}
      >
        <div className="no-organization-modal-body">
          <p className="no-organization-modal-text">{NO_ORG_MESSAGE}</p>
        </div>
        <footer className="modal-footer">
          <button
            type="button"
            className="modal-footer-button"
            onClick={handleNoOrgModalClose}
          >
            Torna al login
          </button>
        </footer>
      </CustomModal>
    </React.Fragment>
  );
}
